import '../css/community_page_header.css'

import chatActiveBanner from '../img/chat_active_banner.png'
import chatInactiveBanner from '../img/chat_inactive_banner.png'
import newsActiveBanner from '../img/news_active_banner.png'
import newsInactiveBanner from '../img/news_inactive_banner.png'
import { useLocation, useNavigate } from 'react-router-dom'
 
function CommunityPageHeader({activeCommunitySubcategory, setActiveCommunitySubcategory, countryName, phoneNumber}){
    const location = useLocation()
    const navigate = useNavigate()

    return <div className="community-page-header">
        <div className="community-page-header-item" style={{
                backgroundImage: `url(${activeCommunitySubcategory === 'Чат' ? chatActiveBanner : chatInactiveBanner})`, // Используем импортированное изображение
                backgroundSize: 'cover', // Настройка размера
                backgroundPosition: 'center', // Центрирование изображения
            }} onClick={() => {
                setActiveCommunitySubcategory('Чат')
                if (location.pathname !== '/') {
                    navigate(`/?phone=${phoneNumber}`)
                }
                }}>
            <div className="community-page-header-item-text">{countryName === 'russia' ? 'ЧАТ' : 'CHAT'}</div>
        </div>
        <div className="community-page-header-item" style={{
                backgroundImage: `url(${activeCommunitySubcategory === 'Новости' ? newsActiveBanner : newsInactiveBanner})`, // Используем импортированное изображение
                backgroundSize: 'cover', // Настройка размера
                backgroundPosition: 'center', // Центрирование изображения
            }} onClick={() => {
                setActiveCommunitySubcategory('Новости')
                if (location.pathname !== '/') {
                    navigate(`/?phone=${phoneNumber}`)
                }
                }}>
            <div className="community-page-header-item-text">{countryName === 'russia' ? 'НОВОСТИ' : 'NEWS'}</div>
        </div>
    </div>
}

export default CommunityPageHeader;